module.exports = __webpack_public_path__ + "static/img/dw4.c5e391a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dw4.jpg
// module id = Qn2L
// module chunks = 1